<template>
  <span
    v-if="isResultTogglerVisible"
    class="result_toggle_item hover-item"
    @click="toggleResult"
    v-tooltip="hideResultTooltip"
    @mouseleave="offResultTooltip"
  >
    <aha-icon
      v-if="!isShowingResult"
      name="show_result"
      viewBox="0 0 24 24"
    ></aha-icon>
    <aha-icon
      v-else
      name="hide_result"
      viewBox="0 0 24 24"
    ></aha-icon>
  </span>
</template>

<script>
import EventBus from '@/eventBus'

const DEFAULT_TIME_CLOSE_TOOLTIP = 3000
export default {
  name: 'ResultAndAnswerToggler',
  props: {
    isResultTogglerVisible: {
      type: Boolean,
      default: false,
    },
    isShowingResult: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isDisplayRevealResultTooltip: false,
    }
  },
  computed: {
    hideResultTooltip() {
      return {
        show: this.isDisplayRevealResultTooltip,
        content: this.isShowingResult ? this.$i18nPresenter.t('Hide results') : this.$i18nPresenter.t('Show results'),
      }
    },
  },
  watch: {
    isDisplayRevealResultTooltip() {
      if (this.isDisplayRevealResultTooltip) {
        setTimeout(() => {
          this.isDisplayRevealResultTooltip = false
        }, DEFAULT_TIME_CLOSE_TOOLTIP)
      }
    },
  },
  mounted() {
    EventBus.$on('display-hide-result-pill-tooltip', () => {
      this.isDisplayRevealResultTooltip = true
    })
  },
  destroyed() {
    EventBus.$off('display-hide-result-pill-tooltip')
    this.isDisplayRevealResultTooltip = false
  },
  methods: {
    toggleResult() {
      this.$emit('toggleResult', !this.isShowingResult)
    },
    offResultTooltip() {
      this.isDisplayRevealResultTooltip = false
    },
  },
}
</script>

<style lang="scss" >

.result_toggle_item {
  cursor: pointer;
  margin-left: 20px;
  display: inline-block;
}
.hover-item {

  position: relative;
  &:hover::after{
      opacity: 1;
  }
  &::after {
    content: "";
    position: absolute;
    opacity: 0;
    transition: all 0.3s ease;
    background: #ebebeb;
    z-index: -1;

    width: 36px;
    height: 36px;
    border-radius: 50%;
    top: -4px;
    left: -6px;
    }

}

.result-icon {
  font-size: 0.8em;
}
</style>
